<template>
  <b-modal
    id="delete-column-configuration-modal"
    class="text-left"
    ref="dialog"
    :title="$t('configuration.delete.title')"
  >
    <span v-html="$t('configuration.delete.text', {configName: configurationName} )"/>
    <template slot="modal-footer">
      <b-button @click="$refs.dialog.hide()">{{$t("configuration.delete.keep")}}</b-button>
      <b-button autofocus variant="danger" @click="onDeleteClick">{{$t("configuration.delete.delete")}}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  computed: {
    configurationName: function() {
      if (this.columnConfiguration.item !== undefined) {
        if(this.columnConfiguration.item.configuration.configurationName == ""){
          return this.columnConfiguration.item.configuration.columnType
        } else return this.columnConfiguration.item.configuration.configurationName;
      }
      return "";
    }
  },
  props: {
    columnConfiguration: {
      type: Object
    }
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    onDeleteClick() {
      this.$refs.dialog.hide();
      this.$emit("confirm", this.columnConfiguration.index);
    }
  }
};
</script>
